if (!customElements.get('copy-address-button')) {
  class CopyAddressButton extends HTMLButtonElement {
    constructor() {
      super();
      this.feedbackTimeout = null;
      this.boundHandleCopy = this.handleCopy.bind(this);
      this.init();
    }
  
    init() {
      if (!this.getAttribute('type')) {
        this.setAttribute('type', 'button');
      }
      
      this.addEventListener('click', this.boundHandleCopy);
      this.setAttribute('aria-label', 'Copy address to clipboard');
      this.setAttribute('title', 'Copy to clipboard');
    }
  
    async handleCopy(event) {
      event.preventDefault();
      
      try {
        const textToCopy = this.getTextToCopy();
        
        if (!textToCopy) {
          console.warn('No text found to copy');
          return;
        }
  
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(textToCopy);
        } else {
          this.fallbackCopyTextToClipboard(textToCopy);
        }
        
        this.showFeedback('Copied!');
        
      } catch (error) {
        console.error('Failed to copy text: ', error);
        this.showFeedback('Failed to copy', true);
      }
    }
  
    getTextToCopy() {
      const parent = this.parentElement;
      if (!parent) return null;    
      const clone = parent.cloneNode(true);
      const buttons = clone.querySelectorAll('copy-address-button, [is="copy-address-button"]');
      buttons.forEach(btn => btn.remove());
      return clone.textContent.trim();
    }
  
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      
      try {
        document.execCommand('copy');
      } finally {
        document.body.removeChild(textArea);
      }
    }
  
    showFeedback(message, isError = false) {
      if (this.feedbackTimeout) {
        clearTimeout(this.feedbackTimeout);
      }
      
      this.classList.add(isError ? '' : 'copied');
      this.disabled = true;
      
      this.feedbackTimeout = setTimeout(() => {
        this.disabled = false;
        this.feedbackTimeout = null;
        this.classList.remove('copied');
      }, 1500);
    }
  
    connectedCallback() {
      if (!this.hasAttribute('aria-label')) {
        this.init();
      }
    }
  
    disconnectedCallback() {
      this.afterDestroy();
    }
  
    afterDestroy() {
      if (this.boundHandleCopy) {
        this.removeEventListener('click', this.boundHandleCopy);
      }
      
      if (this.feedbackTimeout) {
        clearTimeout(this.feedbackTimeout);
        this.feedbackTimeout = null;
      }
      
      this.disabled = false;
      
      console.log('CopyAddressButton cleaned up');
    }
  }
  
  customElements.define('copy-address-button', CopyAddressButton, { extends: 'button' });
}
